// ** Routes Imports
import PagesRoutes from './Pages'
// ** Document title
const TemplateTitle = 'Brasal Corretora'

// ** Default Route
const DefaultRoute = '/home'

// ** Merge Routes
const Routes = [...PagesRoutes]

export { DefaultRoute, TemplateTitle, Routes }
